import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import 'element-plus/dist/index.css'; // 引入样式文件，确保样式正确加载
import ElementPlus from 'element-plus';
import { ElMessage } from "element-plus";
import locale from 'element-plus/es/locale/lang/zh-cn'
import axios from 'axios';
import store from './store';
import TlbsMap from 'tlbs-map-vue';

//请求拦截
axios.interceptors.request.use(config => {
    const isThird = config.url.includes("http");
    config.url = isThird ? config.url : "/kekon" + config.url;
    if (isThird) {
        const thirdToken = store.state.thirdToken
        if (thirdToken && !config.url.includes("findAccessToken")) {
            // config.headers["Authorization"] = `Bearer ${thirdToken}`
        }
    } else {
        const userInfo = store.state.userInfo
        if (userInfo && userInfo.token) {
            config.headers["Authorization"] = `Bearer ${userInfo.token}`
        }
    }
    return config;
}, error => {
    return Promise.reject(error)
})
//响应拦截
axios.interceptors.response.use(async response => {
    if (response.data.code === 406) {
        //续签
        try {
            const userInfo = store.state.userInfo
            if (!response.config._retry && userInfo && userInfo.refreshToken) {
                response.config._retry = true;
                const res = await axios.post("/Login/refresh", userInfo.refreshToken)
                store.commit("setUserInfo", res.data.data);
                response.config.headers.Authorization = `Bearer ${userInfo.refreshToken}`;
                return axios(response.config); // 重试原始请求
            } else {
                store.commit("removeUserInfo");
                location.reload();
            }
        } catch (refresherror) {
            store.commit("removeUserInfo");
            location.reload();
        }

    } else if (response.data.code === 407) {
        ElMessage.success(response.data.description);
        store.commit("removeUserInfo");
        location.reload();
    }
    return response;
}, error => {
    // console.log("err----------", error)
    const status = error.response.status;
    if (status === 406) {
        console.log("--------", error.response.config)
    } else if (error.response.status === 404) {
        ElMessage.error('未找到请求接口')
    } else if (error.response.status === 500) {
        ElMessage.error('系统异常，请联系系统管理员')
    }
    return Promise.reject(error);
})
//定义根组件

//创建实例并挂载到页面
const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementPlus, { locale });
app.use(TlbsMap);
app.config.globalProperties.$axios = axios;
app.mount('#app');
